import { render, staticRenderFns } from "./PerformanceMaterials.vue?vue&type=template&id=94077ee2&scoped=true"
import script from "./PerformanceMaterials.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformanceMaterials.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PerformanceMaterials.vue?vue&type=style&index=0&id=94077ee2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94077ee2",
  null
  
)

export default component.exports